// composables/useScrollToFirstError.js
import { nextTick } from 'vue'

export const useScrollToFirstError = (rootRef) => {
    const scroll = async () => {
        await nextTick()

        const target = rootRef.value?.querySelector('[aria-invalid="true"], [role="alert"]')

        target?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        })

        target?.focus?.({ preventScroll: true })
    }

    return { scroll }
}
